import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const GENERIC_IMAGE_WATERMARK_CLASS_NAME = 'GenericImageWatermark';
export const GENERIC_IMAGE_WATERMARK_CLASS_SLOTS = ['root'] as const;

export type GenericImageWatermarkClassSlot =
	(typeof GENERIC_IMAGE_WATERMARK_CLASS_SLOTS)[number];

export interface GenericImageWatermarkClasses {
	root: string;
	customIcon: string;
	image: string;
	imageWrapper: string;
	skeleton: string;
	watermark: string;

	landscape: string;
	portrait: string;
}

export type GenericImageWatermarkClassKey = keyof GenericImageWatermarkClasses;

export const getGenericImageWatermarkUtilityClass = (slot: string) =>
	generateUtilityClass(GENERIC_IMAGE_WATERMARK_CLASS_NAME, slot);

export const genericImageWatermarkClasses = generateUtilityClasses<
	keyof GenericImageWatermarkClasses
>(GENERIC_IMAGE_WATERMARK_CLASS_NAME, ['root']);
export default genericImageWatermarkClasses;
